import {Card, Col, Collapse, Container, Row} from "react-bootstrap";
import {convertDescriptionPrefix, covertJobTitle, determinBorder, determinColor, getDisplayStatus} from "../service/jobutil";
import UpdateButtonMenu from "./UpdateJobButtonMenu";
import {useState} from "react";
import JobImageGallary from "./JobImageGallary";
import {ParkingFee} from "./parkingfee/ParkingFee";
import {CopyAddress} from "./CopyAddress";
import {ExtraCleaningFee} from "./ExtraCleaningFee";
import {CheckList} from "./checklist/CheckList";
import {ChecklistStatus} from "./checklist/ChecklistStatus";
import {PropertyIssue} from "./propertyissue/PropertyIssue";


export default function JobCardList({job, fieldWorkerMap, fieldSupervisorMap, isLoading, onEditJob, onJobUpdated}) {

    const [open, setOpen] = useState(false);
    const [images, setImages] = useState([])
    return (
        <div style={{marginBottom: "3px"}}>
            <Container fluid>
                <Row>
                    <Col>
                        <Card style={{textAlign: "left", userSelect: "text"}}
                              draggable={!isLoading}
                              onDragStart={(ev) => ev.dataTransfer.setData('cos_job_id', job.cos_job_id)}
                              border={determinBorder(job)}>

                            <Card.Body>
                                <div onClick={() => setOpen(!open)}>
                                    <div style={{display: "flex"}}>
                                          <span>
                                            <b>{covertJobTitle(job)}</b>
                                            {job.tags && job.tags.includes("B2B_NEW") ? (
                                                <span style={{
                                                    display: "inline-block",
                                                    backgroundColor: "#fff",
                                                    color: "red",
                                                    border: "1.5px solid red",
                                                    borderRadius: "4px",
                                                    padding: "2px 8px",
                                                    fontSize: "0.85em",
                                                    fontWeight: 600,
                                                    marginLeft: "8px",
                                                    marginRight: "4px",
                                                    verticalAlign: "middle"
                                                }}>B2B_NEW</span>
                                            ) : job.check_in ? (
                                                <span style={{
                                                    display: "inline-block",
                                                    backgroundColor: "#fff",
                                                    color: determinColor(job),
                                                    border: `1.5px solid ${determinColor(job)}`,
                                                    borderRadius: "4px",
                                                    padding: "2px 8px",
                                                    fontSize: "0.85em",
                                                    fontWeight: 600,
                                                    marginLeft: "8px",
                                                    marginRight: "4px",
                                                    verticalAlign: "middle"
                                                }}>B2B</span>
                                            ) : null}
                                            <CopyAddress job={job}/>
                                          </span>
                                        <span style={{
                                            marginLeft: "auto", color: determinColor(job)
                                        }}><b>{getDisplayStatus(job)}</b></span>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                                        <span style={{flex: 1}}><b>Job ID:</b> {job.cos_job_id}</span>

                                        <div style={{flex: 1, display: "flex", justifyContent: "center"}}>
                                            <div style={{display: "flex"}}>
                                                <ParkingFee job={job}/>
                                                <ExtraCleaningFee job={job}/>
                                                <CheckList job={job} fieldSupervisorMap={fieldSupervisorMap}
                                                           fieldWorkerMap={fieldWorkerMap}/>
                                                <ChecklistStatus job={job} onJobUpdated={onJobUpdated}/>
                                                <PropertyIssue job={job}/>
                                            </div>
                                        </div>
                                        <span style={{flex: 1, textAlign: "right"}}>Date: {job.date}</span>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>


                                        <span style={{
                                            flex: 1, textAlign: "left"
                                        }}><b>Supervisor: </b>{fieldSupervisorMap[job.cos_job_supervisor] ? fieldSupervisorMap[job.cos_job_supervisor] : 'None'}</span>
                                        <span style={{
                                            flex: 1, textAlign: "right"
                                        }}><b>Worker: </b>{fieldWorkerMap[job.cos_job_worker] || ""}</span>
                                    </div>
                                </div>
                                <Collapse in={open}>
                                    <div>
                                        <div>
                                            <span>{convertDescriptionPrefix(job, true)}</span>
                                        </div>
                                        <div style={{marginTop: "20px"}}>
                                            <span>{job.description}</span>
                                        </div>

                                        <div style={{display: "flex", marginTop: "20px"}}>
                                <span>
                                    {job.email}<br/>
                                    {job.phone}</span>
                                            <span style={{marginLeft: "auto"}}>
                                        <UpdateButtonMenu row={job} onClick={onEditJob}/><br/>
                                    </span>
                                        </div>
                                        {open && <JobImageGallary job={job}
                                                                  images={images}
                                                                  isReadOnly={true}
                                                                  setImages={setImages}/>}

                                    </div>
                                </Collapse>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>


        </div>)
}
